import { gql } from "@apollo/client";

export const REVERTIR_DIFERENCIA = gql`
mutation revertirDiferencia($idPeriodo: Int!) {
    revertirDiferencia(idPeriodo: $idPeriodo) {
        success
        valorEsperado
        error
    }
}`;